import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Quantity control. `size="lg"`: solid brand squares (dish screen, diners).
 * `size="sm"`: small squares inside full 44px tap targets (order lines).
 */
const Stepper = ({ value, onDecrease, onIncrease, min = 1, size = "lg" }) => {
  const { t } = useTranslation();
  if (size === "sm") {
    const inner = "w-[30px] h-[30px] rounded-sm flex items-center justify-center text-base font-bold";
    return (
      <div className="flex items-center">
        <button type="button" onClick={onDecrease} aria-label={t("Decrease")} className="w-11 h-11 flex items-center justify-center">
          <span className={`${inner} bg-secondary text-dark`}>−</span>
        </button>
        <span className="w-4 text-center text-base font-bold tabular-nums">{value}</span>
        <button type="button" onClick={onIncrease} aria-label={t("Increase")} className="w-11 h-11 flex items-center justify-center">
          <span className={`${inner} bg-primary text-white`}>+</span>
        </button>
      </div>
    );
  }
  const btn =
    "w-11 h-11 rounded-md bg-primary text-white text-xl font-bold shadow-brand flex items-center justify-center disabled:opacity-40 disabled:shadow-none";
  return (
    <div className="flex items-center gap-2.5">
      <button type="button" onClick={onDecrease} disabled={value <= min} aria-label={t("Decrease")} className={btn}>
        −
      </button>
      <span className="w-6 text-center text-lg font-bold tabular-nums">{value}</span>
      <button type="button" onClick={onIncrease} aria-label={t("Increase")} className={btn}>
        +
      </button>
    </div>
  );
};

export default Stepper;
